import { Component, ViewChild, type OnInit } from '@angular/core'
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog'
import { TriggerApiCallsService } from '../../core/services/cancel-api-call'
import { ToastAlertComponent } from '../../03_shared-components/01_alerts/toast-alert/toast-alert.component'
import { BusinessRulesEngineAPIs } from '../../core/apis/business-rules-engine_api-calls'
import {
  type AbstractControl,
  type FormArray,
  FormBuilder,
  type FormControl,
  type FormGroup,
  type ValidationErrors,
  type ValidatorFn,
  Validators
} from '@angular/forms'
import { type MatAutocompleteSelectedEvent } from '@angular/material/autocomplete'
import { CheckIsFloat, CheckIsInteger } from 'src/app/03_shared-components/forms/form-error-handling/form-validators'
import { ActionConditionFormComponent } from 'src/app/02_shared-features/action-condition-form/action-condition-form.component'
import { has } from 'lodash'

// interface Condition {
//   formGroup: FormGroup
//   condition_id: number
//   condition_name: string
//   inputs: ConditionInput[]
// }

// interface ConditionInput {
//   input_name: string
//   input_type: string
//   input_value?: any
//   options: any[] | any // could be an object that maps first input to lists of options for second
//   data_query?: string
// }

// interface Action {
//   formGroup: FormGroup
//   action_id: number
//   action_name: string
//   inputs: ActionInput[]
// }

// interface ActionInput {
//   input_name: string
//   input_type: string
//   input_value?: any
//   options: any[]
//   data_query?: string
// }

// interface ConditionChoice {
//   condition_id: number
//   category: string
//   condition: string
//   inputs: ConditionInput[]
//   options: any[] | any
//   // datatype: string
//   // options: any[]
//   // data_query: string
// }

// interface ActionChoice {
//   action_id: number
//   category: string
//   action_title: string
//   inputs: ActionInput[]
//   options: any[]
// }

@Component({
  standalone: false,
  selector: 'app-business-rules-engine-modal',
  templateUrl: './business-rules-engine-modal.component.html',
  styleUrl: './business-rules-engine-modal.component.scss'
})
export class BusinessRulesEngineModalComponent implements OnInit {
  loading: boolean = true
  saveDisabled: boolean = false
  loadingMessage: string = 'loading'
  conditionFormArray: FormArray
  actionFormArray: FormArray

  // conditionChoices: ConditionChoice[]
  // filteredConditionChoices: any[] = []
  // filteredConditionValueOptions: Record<number, any[]> = {}
  // filteredActionChoices: any[] = []
  // filteredActionInputOptions: Record<string, any[]> = {}
  // actionChoices: ActionChoice[]
  existingRules: any[]
  runRule = false

  allowedActionChoices = []

  conditionCount = 0
  actionCount = 0

  @ViewChild('conditionsForm') conditionsForm: ActionConditionFormComponent
  @ViewChild('actionsForm') actionsForm: ActionConditionFormComponent

  ruleForm: FormGroup

  get title (): string {
    if (this.config?.data?.mode === 'copy') {
      return 'Copy Rule'
    } else if (this.config?.data?.mode === 'edit') {
      return 'Edit Rule'
    } else {
      return 'Add Rule'
    }
  }

  constructor (
    private readonly dynamicDialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public dialogService: DialogService,
    public triggerApiCallsService: TriggerApiCallsService,
    public toastAlert: ToastAlertComponent,
    private readonly businessRulesEngineAPIs: BusinessRulesEngineAPIs,
    private readonly formBuilder: FormBuilder
  ) {
    this.conditionFormArray = this.formBuilder.array([], this.checkChildErrors())
    this.actionFormArray = this.formBuilder.array([], this.checkChildErrors())
    this.ruleForm = this.formBuilder.group({
      name: ['', [Validators.required, this.uniqueRuleNameValidator()]],
      description: ['']
    })
    // this.ruleForm.addValidators(() => {
    // })
  }

  ngOnInit (): void {
    console.log('rule config modal data', this.config?.data)
    // this.conditionChoices = this.config?.data?.conditions ?? []
    // this.actionChoices = this.config?.data?.actions ?? []
    this.existingRules = this.config?.data?.existingRules ?? []

    // if we are in edit mode, it's okay for the rule name to match the existing name
    if (this.config?.data?.mode === 'edit') {
      this.existingRules = this.existingRules.filter(rule => rule.rule_id !== this.config.data.rule.rule_id)
    }

    let allowedActions = null

    // pre-populate the form with the data from the given rule
    if (this.config?.data?.rule) {
      const rule = this.config.data.rule
      console.log('editing rule', this.config.data.rule)
      this.name.setValue(rule.rule_name)
      this.description.setValue(rule.rule_description)
      rule.conditions.forEach(condition => {
        if (condition.allowed_actions) {
          if (allowedActions) {
            allowedActions = allowedActions.filter(action => condition.allowed_actions.includes(action))
          } else {
            allowedActions = condition.allowed_actions
          }
        }
      })

      // for (let i = 0; i < rule.conditions.length; i++) {
      //   const condition = JSON.parse(JSON.stringify(rule.conditions[i]))
      //   // const conditionChoice = this.conditionChoices.find(
      //   //   conditionChoice => conditionChoice.condition_id == condition.condition_id
      //   // )
      //   // this.addCondition(conditionChoice, condition)

      //   console.log('for editing rule, adding conditions', condition)
      //   condition.inputs = condition.action_inputs
      //   const conditionChoice = this.conditionChoices.find(
      //     conditionChoice => conditionChoice.condition_id == condition.condition_id
      //   )
      //   console.log('found conditionChoice', conditionChoice)
      //   console.log('from conditionChoices', this.conditionChoices)
      //   condition.inputs.forEach((input, index) => {
      //     input['input_type'] = conditionChoice.inputs[index].input_type
      //     if (input.input_type === 'boolean' && typeof input.input_value !== 'boolean') {
      //       input.input_value = input.input_value.toLowerCase() === 'true'
      //     }
      //     if (input.input_type === 'pct') {
      //       input.input_value = input.input_value * 100
      //     }
      //     if (conditionChoice.inputs[index].options) {
      //       input.options = [...conditionChoice.inputs[index].options]
      //     }
      //   })

      //   this.addCondition(conditionChoice, condition)
      // }

      // for (const action of rule.actions) {
      //   console.log('for editing rule, adding actions', action)
      //   action.inputs = action.action_inputs
      //   const actionChoice = this.actionChoices.find(
      //     actionChoice => actionChoice.action_id == action.action_id
      //   )
      //   console.log('found actionChoice', actionChoice)
      //   console.log('from actionChoices', this.actionChoices)
      //   action.inputs.forEach((input, index) => {
      //     input['input_type'] = actionChoice.inputs[index].input_type
      //     if (input.input_type === 'boolean' && typeof input.input_value !== 'boolean') {
      //       input.input_value = input.input_value.toLowerCase() === 'true'
      //     }
      //     if (input.input_type === 'pct') {
      //       input.input_value = input.input_value * 100
      //     }
      //     if (actionChoice.inputs[index].options) {
      //       input.options = [...actionChoice.inputs[index].options]
      //     }
      //   })

      //   this.addAction(actionChoice, action)
      // }
    }
    // this.filteredConditionChoices = this.conditionChoices
    // this.filteredActionChoices = this.actionChoices

    // this.conditions.forEach((condition: any, index: number) => {
    //   if (condition.options) {
    //     this.filteredConditionValueOptions[index] = condition.options
    //   }
    // })
    this.updateAllowedActions(allowedActions)
    this.loading = false
  }

  // consoleprint (data) {
  //   console.log('consoleprint', data)
  // }

  // get conditions (): FormArray {
  //   return this.ruleForm.get('conditions') as FormArray
  // }

  // conditions: Condition[] = []

  // actions: Action[] = []

  get name () {
    return this.ruleForm.get('name') as FormControl
  }

  get description () {
    return this.ruleForm.get('description') as FormControl
  }

  // addCondition (conditionChoice = {}, condition: Condition = undefined) {
  //   console.log('adding conditionChoice', conditionChoice)
  //   // const buildingCondition = {
  //   //   condition_id: condition?.condition_id,
  //   //   condition_name: condition?.condition_name,
  //   //   formGroup: this.formBuilder.group(
  //   //     {},
  //   //     {
  //   //       validators: this.checkChildErrors()
  //   //     }
  //   //   ),
  //   //   input_name: condition?.input_name,
  //   //   options: conditionChoice['options'], // these are the input options
  //   //   datatype: condition?.datatype
  //   // }

  //   // buildingCondition.formGroup.addControl('condition_name', new FormControl(conditionChoice))

  //   // this.conditionFormArray.push(buildingCondition['formGroup'])
  //   // this.conditions.push(buildingCondition)

  //   // if (condition !== undefined) {
  //   //   console.log('adding input from edit')
  //   //   this.addConditionInput(buildingCondition, conditionChoice as ConditionChoice, condition.input_value)
  //   // }
  //   const buildingCondition = {
  //     formGroup: this.formBuilder.group(
  //       {
  //         condition_name: [conditionChoice, [Validators.required]],
  //         inputs: new FormGroup({}, this.checkChildErrors())
  //       },
  //       {
  //         validators: this.checkChildErrors()
  //       }
  //     ),
  //     condition_id: conditionChoice['condition_id'],
  //     condition_name: conditionChoice['condition_name'],
  //     inputs: condition ? condition['inputs'] : []
  //   }

  //   this.conditionFormArray.push(buildingCondition['formGroup'])
  //   this.conditions.push(buildingCondition)

  //   if (condition) {
  //     this.addConditionInputs(condition['inputs'], buildingCondition, conditionChoice as ConditionChoice)
  //   }
  // }

  // removeCondition (i: number) {
  //   this.conditionFormArray.removeAt(i)
  //   this.conditions.splice(i, 1)
  // }

  // addAction (actionChoice = { inputs: [] }, action: Action = undefined) {
  //   const buildingAction = {
  //     formGroup: this.formBuilder.group(
  //       {
  //         action_name: [actionChoice, [Validators.required]],
  //         inputs: new FormGroup({}, this.checkChildErrors())
  //       },
  //       {
  //         validators: this.checkChildErrors()
  //       }
  //     ),
  //     action_id: actionChoice['action_id'],
  //     action_name: actionChoice['action_name'],
  //     inputs: action ? action['inputs'] : []
  //   }

  //   this.actionFormArray.push(buildingAction['formGroup'])
  //   this.actions.push(buildingAction)

  //   if (action) {
  //     this.addActionInputs(action['inputs'], buildingAction, actionChoice as ActionChoice)
  //   }
  // }

  // removeAction (i: number) {
  //   this.actionFormArray.removeAt(i)
  //   this.actions.splice(i)
  // }

  // addConditionInputs (inputs: ConditionInput[], condition: Condition, conditionChoice: ConditionChoice = undefined) {
  //   const inputFormGroup = condition.formGroup.get('inputs') as FormGroup
  //   condition.inputs.forEach(input => {
  //     inputFormGroup.removeControl(input.input_name)
  //   })
  //   condition.formGroup.addControl('inputs', inputFormGroup)
  //   condition.inputs = []
  //   console.log('adding all condition inputs', inputs)
  //   for (let i = 0; i < inputs.length; i++) {
  //     const input = inputs[i]
  //     const validators = this.getValidators(input.input_type)

  //     console.log('input.options', input.options)

  //     console.log('adding control of name', input.input_name)

  //     inputFormGroup.addControl(
  //       input.input_name,
  //       new FormControl(conditionChoice ? input.input_value : '', { validators })
  //     )

  //     console.log('added form control', inputFormGroup.get(input.input_name))

  //     condition.inputs.push({
  //       input_name: input.input_name,
  //       input_type: input.input_type,
  //       options: inputs[i].options
  //     })
  //   }
  // }

  // addConditionInput (condition: Condition, selectedOption: ConditionChoice, value = undefined) {
  //   console.log('addconditioninput')
  //   console.log('condition', condition)
  //   console.log('selectedOption', selectedOption)

  //   const validators = this.getValidators(condition.datatype)
  //   console.log('validators', validators)
  //   condition.formGroup.addControl(
  //     condition.input_name,
  //     new FormControl(value !== undefined ? value : '', validators)
  //   )

  //   // inputs.push(this.formBuilder.control('', validators))
  //   // console.log('inputs', inputs)
  //   // console.log('validators', validators)
  // }

  async onSubmit () {
    this.saveDisabled = true
    console.log('this.name', this.name)
    console.log('this.ruleForm', this.ruleForm)
    console.log('this.description', this.description)

    let checkProducts = []
    const badProductsConditions = {}
    const badProductsActions = {}

    const rule = {
      rule_name: this.name.value.trim(),
      rule_description: this.description.value,
      conditions: this.conditionsForm.parents.map(parent => {
        // return {
        //   condition_id: condition.condition_id,
        //   input_name: condition.input_name,
        //   input_value: condition.formGroup.get(condition.input_name).value
        // }
        return {
          condition_id: parent.parent_id,
          condition_inputs: parent.inputs.map(input => {
            console.log('badProductsConditions', badProductsConditions)
            checkProducts = checkProducts.concat(
              this.buildCheckProducts(parent, input, badProductsConditions)
            )
            console.log('badProductsConditions after', badProductsConditions)
            return {
              input_name: input.input_name,
              input_value: parent.formGroup.get('inputs').get(input.input_name).value
            }
          })
        }
      }),
      actions: this.actionsForm.parents.map((parent, index) => {
        return {
          action_id: parent.parent_id,
          action_execution_order: index,
          action_inputs: parent.inputs.map(input => {
            console.log('badProductsActions', badProductsActions)
            checkProducts = checkProducts.concat(
              this.buildCheckProducts(parent, input, badProductsActions)
            )
            console.log('badProductsActions after', badProductsActions)
            return {
              input_name: input.input_name,
              input_value: parent.formGroup.get('inputs').get(input.input_name).value
            }
          })
        }
      })
    }

    const response = checkProducts.length
      ? await this.businessRulesEngineAPIs.CheckProducts(checkProducts)
      : { data: [] }
    let hasErrors = false
    console.log('checking badProductsConditions', badProductsConditions)
    console.log('checking badProductsActions', badProductsActions)
    console.log('with response data', response.data)
    if (response.data.length) {
      // some products don't exist!
      console.log('found nonexistant products', response.data)
      Object.keys(badProductsConditions).forEach(key => {
        badProductsConditions[key] = badProductsConditions[key].filter((product_id: string) => {
          return response.data.includes(product_id)
        })
        hasErrors = hasErrors || badProductsConditions[key].length
      })
      Object.keys(badProductsActions).forEach(key => {
        badProductsActions[key] = badProductsActions[key].filter((product_id: string) => {
          return response.data.includes(product_id)
        })
        hasErrors = hasErrors || badProductsActions[key].length
      })
      // response.data.forEach(product_id => {
      //   if (Object.hasOwn(badProductsConditions, product_id)) {
      //     badProductsConditions[product_id].forEach((affectedInput: string) => {
      //       hasErrors = hasErrors || this.checkBadProduct(this.conditionsForm, affectedInput, product_id)
      //     })
      //   }
      //   if (Object.hasOwn(badProductsActions, product_id)) {
      //     console.log('product in actions', product_id)
      //     badProductsActions[product_id].forEach((affectedInput: string) => {
      //       hasErrors = hasErrors || this.checkBadProduct(this.actionsForm, affectedInput, product_id)
      //     })
      //   }
      // })
      this.conditionsForm.badProducts = badProductsConditions
      this.actionsForm.badProducts = badProductsActions
      for (let i = 0; i < this.actionsForm.parentFormArray.length; i++) {
        Object.values((this.actionsForm.parentFormArray.at(i).get('inputs') as FormGroup).controls).forEach(
          val => {
            val.updateValueAndValidity()
          }
        )
      }
      for (let i = 0; i < this.conditionsForm.parentFormArray.length; i++) {
        Object.values((this.conditionsForm.parentFormArray.at(i).get('inputs') as FormGroup).controls).forEach(
          val => {
            val.updateValueAndValidity()
          }
        )
      }
    }

    console.log('rule', rule)

    if (!hasErrors) {
      this.loading = true
      if (this.config.data.mode === 'edit') {
        await this.editRule(rule)
      } else {
        await this.addRule(rule)
      }
      this.close()
    } else {
      this.saveDisabled = false
    }
  }

  buildCheckProducts (parent: any, input: any, badProductsMap: any): string[] {
    const key = parent.parent_id + '|' + input.input_name
    let value = parent.formGroup.get('inputs').get(input.input_name).value
    let checkProducts = []
    if (input.data_query === 'products') {
      if (!Array.isArray(value)) {
        value = [value]
      }
      console.log('pushing value', value)
      if (!badProductsMap[key]) {
        console.log('creating badProductsMap key', value)
        badProductsMap[key] = value
      } else {
        badProductsMap[key] = badProductsMap[key].concat(value)
      }
      checkProducts = checkProducts.concat(value)
      console.log('checkproducts after concat value', checkProducts)
    }
    // if (input.input_type === 'pct' && value) {
    //   value = value / 100
    // }
    return checkProducts
  }

  private async addRule (rule) {
    console.log('rule', rule)

    const response = await this.businessRulesEngineAPIs.CreateRule(rule)

    if (response.is_success) {
      this.config.data.success(response.data, this.runRule)
    }
  }

  private async editRule (rule) {
    console.log('saving edited rule', rule)
    const data = {
      ...rule,
      rule_id: this.config.data.rule.rule_id,
      rule_description: this.description.value || this.config.data.rule.rule_description || '',
      priority_order: this.config.data.rule.priority_order,
      is_active: this.config.data.rule.is_active
    }

    console.log('data to update rule', data)

    const response = await this.businessRulesEngineAPIs.UpdateRule(data)

    if (response.is_success) {
      this.config.data.success(response.data[0], this.runRule)
    }
  }

  getActionInputs (action: AbstractControl): FormArray {
    return action.get('action_inputs') as FormArray
  }

  getConditionInputs (condition): FormArray {
    return condition.formGroup.get('input_value') as FormArray
  }

  displayConditionOptions (option): string {
    return option.condition
  }

  displayActionOptions (option): string {
    return option.action_title
  }

  // displayActionInputOptions (option): string {
  //   console.log('displayactioninoput', option)
  //   return option.value
  // }

  close (data?: any) {
    if (this.dynamicDialogRef) {
      this.dynamicDialogRef.close(data || null)
    }
  }

  private uniqueRuleNameValidator (): ValidatorFn {
    return (control: FormControl): ValidationErrors | null => {
      // HACK: prevent the validator from running when the form is first initialized
      if (!this.existingRules || this.existingRules.length === 0) {
        return null
      }

      if (this.existingRules.some(rule => rule.rule_name === control.value.trim())) {
        return { unique: true }
      }

      return null
    }
  }

  // onConditionSelected (event: MatAutocompleteSelectedEvent, index: number) {
  //   console.log('event.option.value', event.option.value)
  //   const selectedOption = event.option.value as ConditionChoice
  //   const condition = this.conditions[index]
  //   // Update the condition object with the selected option's properties
  //   condition.condition_id = selectedOption.condition_id

  //   this.addConditionInputs(selectedOption.inputs, condition)

  //   console.log('this.actions', this.actions)

  //   condition.formGroup.updateValueAndValidity()

  //   // const actionsArray = this.ruleForm.get('actions') as FormArray
  //   // const actionGroup = actionsArray.at(index) as FormGroup

  //   // // Update the form controls with the selected option's properties
  //   // actionGroup.patchValue({
  //   //   action_id: selectedOption.action_id,
  //   //   action_name: selectedOption.action_title,
  //   //   action_execution_order: index + 1,
  //   //   options: selectedOption.options
  //   // })

  //   // Add the correct number of inputs with the correct names, etc.
  //   this.filteredConditionChoices = this.conditionChoices

  //   if (condition.inputs) {
  //     condition.inputs.forEach((input: any) => {
  //       if (input.options) {
  //         const key = `${index}-${input.input_name}`
  //         console.log(
  //           'adding filtered condition input options',
  //           key,
  //           input.options,
  //           this.filteredConditionInputOptions
  //         )
  //         this.filteredConditionInputOptions[key] = [...input.options]
  //       }
  //     })
  //   }
  //   // console.log('event option', event.option)
  //   // const selectedOption = event.option.value as ConditionChoice
  //   // const condition = this.conditions[index]
  //   // console.log(condition.formGroup)
  //   // if (condition.formGroup.contains('value')) {
  //   //   condition.formGroup.get('value').reset()
  //   // }
  //   // if (condition.formGroup.contains('value2')) {
  //   //   condition.formGroup.get('value2').reset()
  //   // }
  //   // // Update the condition object with the selected option's properties
  //   // if (condition.condition_id && condition.condition_id === selectedOption.condition_id) {
  //   //   // Add value as condition input
  //   //   this.addConditionInput(condition, selectedOption, true)
  //   // } else {
  //   //   // new condition
  //   //   condition.condition_id = selectedOption.condition_id
  //   //   condition.condition_name = selectedOption.condition
  //   //   condition.input_name = 'value'
  //   //   condition.options = selectedOption.options
  //   //   condition.datatype = selectedOption.datatype

  //   //   if (Object.hasOwn(selectedOption, 'input_name2')) {

  //   //   }

  //   //   // Add a new condition input
  //   //   this.addConditionInput(condition, selectedOption)
  //   // }
  //   // this.filteredConditionChoices = this.conditionChoices

  //   // const selectedCondition = event.option.value
  //   // if (selectedCondition.options) {
  //   //   this.filteredConditionValueOptions[index] = selectedCondition.options
  //   // }
  // }

  // filterConditionOptions (searchTerm: string): void {
  //   if (!searchTerm) {
  //     this.filteredConditionChoices = this.conditionChoices
  //     return
  //   }

  //   this.filteredConditionChoices = this.conditionChoices.filter(option =>
  //     option.condition.toLowerCase().includes(searchTerm.toLowerCase())
  //   )
  // }

  // onConditionInputChange (event: any, index: number): void {
  //   const searchTerm = event.target.value
  //   this.filterConditionOptions(searchTerm)
  // }

  // onConditionValueChanged (event, index) {
  //   console.log('conditionvaluechanged', event)
  // }

  // filterConditionValueOptions (searchTerm: string, conditionIndex: number, inputIndex: input): void {
  //   const condition = this.conditions[conditionIndex]

  //   if (!condition.options) {
  //     return
  //   }

  //   if (!searchTerm) {
  //     this.filteredConditionValueOptions[conditionIndex] = condition.options
  //     return
  //   }

  //   this.filteredConditionValueOptions[conditionIndex] = condition.options.filter((option: string) =>
  //     option.toLowerCase().includes(searchTerm.toLowerCase())
  //   )
  // }

  // onConditionValueInputChange (event: any, conditionIndex: number): void {
  //   const searchTerm = event.target.value
  //   this.filterConditionValueOptions(searchTerm, conditionIndex)
  // }

  // onConditionInputOptionSelected(event: any, condition: ConditionChoice): void {
  //   if (conditionChoice)
  // }

  // getFilteredValueOptions (index: number): any[] {
  //   return this.filteredConditionValueOptions[index] || []
  // }

  // onActionValueChanged (event, index) {
  //   console.log(event)
  // }

  // onActionSelected (event: MatAutocompleteSelectedEvent, index: number) {
  //   console.log('event.option.value', event.option.value)
  //   const selectedOption = event.option.value as ActionChoice
  //   const action = this.actions[index]
  //   // Update the condition object with the selected option's properties
  //   action.action_id = selectedOption.action_id
  //   action.action_name = selectedOption.action_title

  //   this.addActionInputs(selectedOption.inputs, action)

  //   console.log('this.actions', this.actions)

  //   action.formGroup.updateValueAndValidity()

  //   // const actionsArray = this.ruleForm.get('actions') as FormArray
  //   // const actionGroup = actionsArray.at(index) as FormGroup

  //   // // Update the form controls with the selected option's properties
  //   // actionGroup.patchValue({
  //   //   action_id: selectedOption.action_id,
  //   //   action_name: selectedOption.action_title,
  //   //   action_execution_order: index + 1,
  //   //   options: selectedOption.options
  //   // })

  //   // Add the correct number of inputs with the correct names, etc.
  //   this.filteredActionChoices = this.actionChoices

  //   if (action.inputs) {
  //     action.inputs.forEach((input: any) => {
  //       if (input.options) {
  //         const key = `${index}-${input.input_name}`
  //         console.log(
  //           'adding filtered action input options',
  //           key,
  //           input.options,
  //           this.filteredActionInputOptions
  //         )
  //         this.filteredActionInputOptions[key] = [...input.options]
  //       }
  //     })
  //   }
  // }

  // addActionInputs (inputs: ActionInput[], action: Action, actionChoice: ActionChoice = undefined) {
  //   const inputFormGroup = action.formGroup.get('inputs') as FormGroup
  //   action.inputs.forEach(input => {
  //     inputFormGroup.removeControl(input.input_name)
  //   })
  //   action.formGroup.addControl('inputs', inputFormGroup)
  //   action.inputs = []
  //   console.log('adding all action inputs', inputs)
  //   for (let i = 0; i < inputs.length; i++) {
  //     const input = inputs[i]
  //     const validators = this.getValidators(input.input_type)

  //     console.log('input.options', input.options)

  //     console.log('adding control of name', input.input_name)

  //     inputFormGroup.addControl(
  //       input.input_name,
  //       new FormControl(actionChoice ? input.input_value : '', { validators })
  //     )

  //     console.log('added form control', inputFormGroup.get(input.input_name))

  //     action.inputs.push({
  //       input_name: input.input_name,
  //       input_type: input.input_type,
  //       options: inputs[i].options
  //     })
  //   }
  // }

  // filterActionOptions (searchTerm: string): void {
  //   if (!searchTerm) {
  //     this.filteredActionChoices = this.actionChoices
  //     return
  //   }

  //   this.filteredActionChoices = this.actionChoices.filter(option =>
  //     option.action_title.toLowerCase().includes(searchTerm.toLowerCase())
  //   )
  // }

  // filterConditionOptions (searchTerm: string): void {
  //   if (!searchTerm) {
  //     this.filteredConditionChoices = this.conditionChoices
  //     return
  //   }

  //   this.filteredActionChoices = this.actionChoices.filter(option =>
  //     option.action_title.toLowerCase().includes(searchTerm.toLowerCase())
  //   )
  // }

  // onActionInputChange (event: any, index: number): void {
  //   const searchTerm = event.target.value
  //   this.filterActionOptions(searchTerm)
  // }

  // filterActionInputOptions (searchTerm: string, actionIndex: number, inputName: string): void {
  //   const action = this.actions[actionIndex]
  //   const input = action.inputs?.find((inp: any) => inp.input_name === inputName)

  //   if (!input?.options) {
  //     return
  //   }

  //   const key = `${actionIndex}-${inputName}`

  //   if (!searchTerm) {
  //     this.filteredActionInputOptions[key] = input.options
  //     return
  //   }

  //   this.filteredActionInputOptions[key] = input.options.filter((option: string) =>
  //     option.toLowerCase().includes(searchTerm.toLowerCase())
  //   )
  // }

  // onActionInputValueChange (event: any, actionIndex: number, inputName: string): void {
  //   const searchTerm = event.target.value
  //   this.filterActionInputOptions(searchTerm, actionIndex, inputName)
  // }

  // getFilteredActionInputOptions (actionIndex: number, inputName: string): any[] {
  //   const key = `${actionIndex}-${inputName}`
  //   const action = this.actions[actionIndex]
  //   const input = action.inputs?.find((inp: any) => inp.input_name === inputName)

  //   // If no filtered options exist yet, return the original options
  //   if (!this.filteredActionInputOptions[key] && input?.options) {
  //     this.filteredActionInputOptions[key] = [...input.options]
  //   }

  //   return this.filteredActionInputOptions[key] || []
  // }

  getValidators (datatype: string) {
    const validators = []

    switch (datatype) {
      case 'boolean':
        break
      case 'integer':
      case 'number':
        validators.push(Validators.required)
        validators.push(CheckIsInteger())
        break
      case 'float':
      case 'pct':
        validators.push(Validators.required)
        validators.push(CheckIsFloat())
        break
      default:
        validators.push(Validators.required)
        break
    }
    validators.push(this.checkChildErrors())

    return validators
  }

  toggleRunRule () {
    this.runRule = !this.runRule
    // console.log('ruleForm', this.ruleForm)
    // console.log('conditions', this.conditions)
    // console.log('actions', this.actions)
    // console.log('controls', this.ruleForm.controls)
    // console.log('this.actionFormArray', this.actionFormArray)
    // console.log('this.conditionFormArray', this.conditionFormArray)
    // this.actions.forEach(action => action.inputs.forEach(input => input.form.updateValueAndValidity()))
    // this.conditions.forEach(condition => condition.formGroup.updateValueAndValidity())
    // this.actions.forEach(action => action.formGroup.updateValueAndValidity())
  }

  // checkChildErrors () {
  //   const valFunc = (control: AbstractControl): ValidationErrors | null => {
  //     console.log('checkchilderrors', control)
  //     if (control.errors) {
  //       return control.errors
  //     } else if (control['controls']) {
  //       console.log('control.controls', control['controls'])
  //       return Object.values(control['controls']).map(control => valFunc(control as any)).filter(val => val)[0]
  //     } else {
  //       return null
  //     }
  //   }
  //   return valFunc
  // }

  checkChildErrors () {
    const valFunc = (control: AbstractControl): ValidationErrors | null => {
      console.log('validating values', control.value)
      if (control['controls']) {
        console.log('control has controls')
        let newErrors = {}
        // if (control.errors) {
        //   newErrors = { ...control.errors }
        // } else {
        //   newErrors = {}
        // }
        for (const c of Object.entries(control['controls'])) {
          console.log('checking control of name', c[0])
          const childControl = c[1] as AbstractControl
          console.log('checkign child control', childControl)
          if (childControl.errors) {
            console.log('childControl has errors', childControl.errors)
            newErrors = {
              ...childControl.errors,
              ...newErrors
            }
          }
        }
        console.log('returning newErrors', newErrors)
        return Object.entries(newErrors).length ? newErrors : null
      }
    }
    return valFunc
  }

  // getToolTip (input: any): string {
  //   let tooltip = ''
  //   if ('condition_name' in input) {
  //     if (input.datatype === 'boolean') {
  //       tooltip = 'Please Enter True or False'
  //     } else if (input.datatype === 'integer') {
  //       tooltip = 'Please Enter A Number Value'
  //     } else if (input.datatype === 'pct') {
  //       tooltip = 'Please Enter A Percentage Value'
  //     } else if (
  //       input.condition_name === 'Size range has <= N sizes' ||
  //               input.condition_name === 'Size range has >= N sizes'
  //     ) {
  //       tooltip = 'Please Enter A Value'
  //     } else if (input.datatype === 'float') {
  //       tooltip = 'Please Enter A Float Value'
  //     } else if (input.condition_name.toLowerCase().includes('size range is')) {
  //       tooltip = 'Please Select A Size Range'
  //     } else if (input.condition_name.toLowerCase().includes('size')) {
  //       tooltip = 'Please Select A Size'
  //     } else if (input.condition_name.toLowerCase().includes('season')) {
  //       tooltip = 'Please Select A Season'
  //     } else if (input.condition_name.toLowerCase().includes('product')) {
  //       tooltip = 'Please Enter A Product'
  //     } else if (
  //       input.condition_name.toLowerCase().includes('profile') &&
  //               input.condition_name.toLowerCase().includes('created by')
  //     ) {
  //       tooltip = 'Please Select An Email'
  //     } else if (input.condition_name.toLowerCase().includes('profile')) {
  //       tooltip = 'Please Select A Channel'
  //     } else {
  //       tooltip = 'Please Enter A Value'
  //     }
  //   } else {
  //     if (input.input_type === 'boolean' || input.input_name === 'TRUE') {
  //       tooltip = 'Please Enter True or False'
  //     } else if (input.input_type === 'integer') {
  //       tooltip = 'Please Enter A Number'
  //     } else if (input.input_type === 'float') {
  //       tooltip = 'Please Enter A Float Value'
  //     } else if (input.input_type === 'pct') {
  //       tooltip = 'Please Enter A Percentage Value'
  //     } else if (input.input_name === 'Size') {
  //       tooltip = 'Please Select A Size'
  //     } else if (input.input_name === 'Old Size') {
  //       tooltip = 'Please Select The Old Size'
  //     } else if (input.input_name === 'Old Size 1') {
  //       tooltip = 'Please Select The First Old Size'
  //     } else if (input.input_name === 'Old Size 2') {
  //       tooltip = 'Please Select The Second Old Size'
  //     } else if (input.input_name === 'New Size') {
  //       tooltip = 'Please Select The New Size'
  //     } else if (input.input_name === 'New Size 1') {
  //       tooltip = 'Please Select The First New Size'
  //     } else if (input.input_name === 'New Size 2') {
  //       tooltip = 'Please Select The Second New Size'
  //     } else if (input.input_name.includes('Store')) {
  //       tooltip = 'Please Select A Store'
  //     } else if (input.input_name === 'Season') {
  //       tooltip = 'Please Select A Season'
  //     } else if (input.input_name === 'To Style-Colors Under Parent Product') {
  //       tooltip = 'Please Enter A Style-Colors Under Parent Product'
  //     } else if (input.input_name.toLowerCase().includes('product')) {
  //       tooltip = 'Please Enter A Product'
  //     } else if (input.input_name === 'Value' || input.input_type === 'text') {
  //       tooltip = 'Please Enter A Value'
  //     }
  //   }
  //   return tooltip
  // }
  updateAllowedActions (allowedActions: number[]) {
    console.log('updating allowed actions', allowedActions)
    console.log('all actions', this.config?.data?.actions)
    this.allowedActionChoices = allowedActions
      ? this.config?.data?.actions.filter(action => allowedActions.includes(action.parent_id))
      : this.config?.data?.actions
    console.log('updating allowed actions choices to', this.allowedActionChoices)
  }
}
